<template>
  <button
    :disabled="disabled"
    @click="action"
    type="button"
    class="btn btn-primary"
    v-html="text"
  />
</template>
<script>
export default {
  props: {
    text: { default: "Simpan" },
    disabled: { default: false },
    action: {
      type: Function,
      default: function () {
        return () => {};
      },
    },
  },
};
</script>